import { RouteItem } from '@eastcoal/router/types/route'

import { ORDER_LIST_PAGE_PATH } from './constants/path'

export const orderListRoute: RouteItem = {
  title: '订单列表',
  path: ORDER_LIST_PAGE_PATH,
  Component: () => import('./index')
}
